import { Rating } from "@edp-models/rating.model";

export interface IRatingState {
    rating: Rating;
}

export const initialRatingState: IRatingState = {
    rating: { showRating: false },
};
